import {
  useAllVehiclesListQuery,
  useAllVehiclesSummaryQuery,
} from "generated/graphql"
import { useCurrentDepartment } from "hooks/useAuth"
import { useSelector } from "react-redux"
import { ApplicationState } from "store"
import { AllVehiclesFilter } from "store/all-vehicles/all-vehicles.types"
import { useCurrentDcId } from "store/auth.redux"
import { getId } from "utils/custom.utils"

export function useAllVehicles() {
  const page = useSelector<ApplicationState, number>(
    state => state.allVehicles.page
  )
  const search = useSelector<ApplicationState, string>(
    state => state.allVehicles.search
  )
  const filter = useSelector<ApplicationState, AllVehiclesFilter>(
    state => state.allVehicles.filter
  )
  return useAllVehiclesListQuery({
    variables: {
      query: search,
      filter: {
        vehicleType: filter.vehicleTypes?.map(getId),
        departmentId: filter.departments?.map(getId),
        status: Object.keys(filter.status).filter(st => filter.status[st]),
      },
      first: 10,
      skip: page * 10,
    },
  })
}

export function useAllVehicleSummary() {
  const departmentId = useCurrentDepartment()
  const dcId = useCurrentDcId()
  const date = useSelector<ApplicationState>(
    state => state.vehicle.selectedDate
  )
  return useAllVehiclesSummaryQuery({
    variables: {
      departmentId,
      distributionCenterId: dcId,
      date,
    },
  })
}
